var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-w":"12"}},[_c('vs-card',{staticClass:"cstm-card w-full mb-4 collapse-cstm-card"},[_c('div',{staticClass:"collapse-item"},[_c('div',{staticClass:"flex justify-between header",class:{activeCollapse: _vm.isCollapseCard},attrs:{"slot":"header"},on:{"click":function($event){_vm.isCollapseCard=!_vm.isCollapseCard}},slot:"header"},[_c('h5',[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"material-icons"},[_vm._v("keyboard_arrow_down")])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCollapseCard),expression:"isCollapseCard"}],staticClass:"collapseContent",class:{active: _vm.isCollapseCard}},[_c('vs-row',[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center"}},[_c('editor',{attrs:{"api-key":_vm.tinyMceApi,"init":{
       height: 500,
       menubar: true,
       branding: false,
       images_upload_url: _vm.image_url,
       automatic_uploads: true,
       images_upload_credentials:true,
       images_upload_handler:_vm.example_image_upload_handler,
       plugins: [
        'autolink lists link image charmap print preview anchor',
        'imagetools',
        'searchreplace visualblocks code fullscreen',
        'insertdatetime media table paste code help wordcount',
        'code lists fullscreen',
        'emoticons'
      ],
       menu:'table',
       toolbar:'insertfile image link |undo redo | formatselect | bold italic backcolor | \
      table alignleft aligncenter alignright alignjustify | \
      bullist numlist outdent indent | removeformat | help',
      
         
     }},model:{value:(_vm.localContentValue),callback:function ($$v) {_vm.localContentValue=$$v},expression:"localContentValue"}})],1)],1)],1)])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }